import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Button } from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-representante-card',
  imports: [CommonModule, Button, ButtonModule, AvatarModule],
  templateUrl: './representante-card.component.html',
  styleUrls: ['./representante-card.component.scss'],
  standalone: true,
})
export class RepresentanteCardComponent implements OnChanges {
  @Input() instituicaoEnsino: any;
  @Input() foto: string | ArrayBuffer | null = null;
  @Input() representante: any;
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() redefinirSenha = new EventEmitter<any>();
  @Output() notificar = new EventEmitter<any>();
  Show = false;
  imageError = false;

  visible: boolean = false;
  showDetalhe: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    this.imageError = false;
  }

  ShowDetais(event: Event) {
    event.stopPropagation();
    this.Show = !this.Show;
  }

  Editar(event: Event) {
    event.stopPropagation();
    this.edit.emit(this.representante);
  }

  RedefinirSenha(event: Event) {
    event.stopPropagation();
    this.redefinirSenha.emit(this.representante);
  }

  deleteEvent(event: Event) {
    event.stopPropagation();
    this.delete.emit(this.representante);
  }

  getInitials(name?: string | null): string {
    return getInitials(name);
  }
}
